import { PRODUCT_MAP, fmt } from "@/lib/load/products";

const X0 = 70, W = 780, Y = 34, H = 104;

export const TankerSvg = ({ compartments, loads, warnings }) => {
  const total = compartments.reduce((a, c) => a + c.capacity, 0) || 1;
  const warnIdx = new Set(warnings.flatMap((w) => [w.left, w.right]));
  let x = X0;
  const parts = compartments.map((c, i) => {
    const w = (W * c.capacity) / total;
    const part = { c, i, x, w, load: loads?.[i] };
    x += w;
    return part;
  });
  return (
    <svg className="load-cutaway" viewBox="0 0 900 180" data-testid="tanker-svg">
      <defs>
        <clipPath id="tank-clip"><rect x={X0} y={Y} width={W} height={H} rx={48} /></clipPath>
        <pattern id="dry-hatch" width="10" height="10" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
          <rect width="10" height="10" fill="rgba(239,68,68,0.12)" /><line x1="0" y1="0" x2="0" y2="10" stroke="#ef4444" strokeWidth="3" />
        </pattern>
      </defs>
      <rect x="20" y="150" width="70" height="8" fill="#334460" rx="2" />
      <text x="24" y="172" className="svg-sub">FRONT</text>
      {[700, 760, 820].map((cx) => <circle key={cx} cx={cx} cy="152" r="16" fill="#0f172a" stroke="#475569" strokeWidth="5" />)}
      <rect x={X0} y={Y} width={W} height={H} rx={48} fill="#0f172a" />
      <g clipPath="url(#tank-clip)">
        {parts.map(({ c, i, x, w, load }) => {
          const p = load?.product && PRODUCT_MAP[load.product];
          const h = p ? (H * load.gallons) / c.capacity : 0;
          return (
            <g key={i}>
              {c.locked_dry && <rect x={x} y={Y} width={w} height={H} fill="url(#dry-hatch)" />}
              {p && <rect x={x} y={Y + H - h} width={w} height={h} fill={p.color} opacity="0.92" className="fill-anim" />}
              {p?.shape === "square" && <rect x={x + 3} y={Y + H - h + 3} width={w - 6} height={Math.max(0, h - 6)} fill="none" stroke="#fff" strokeWidth="2" />}
              {p?.mark === "OFF" && <rect x={x} y={Y + H - h} width={w} height={Math.min(h, 8)} fill="#dc2626" />}
              {i > 0 && (c.double_bulkhead || compartments[i - 1].double_bulkhead)
                ? [-4, 4].map((d) => <line key={d} x1={x + d} y1={Y} x2={x + d} y2={Y + H} stroke={warnIdx.has(i) && warnIdx.has(i - 1) ? "#f59e0b" : "#94a3b8"} strokeWidth="3" />)
                : i > 0 && <line x1={x} y1={Y} x2={x} y2={Y + H} stroke={warnIdx.has(i) && warnIdx.has(i - 1) ? "#f59e0b" : "#334460"} strokeWidth="4" />}
            </g>
          );
        })}
      </g>
      <rect x={X0} y={Y} width={W} height={H} rx={48} fill="none" stroke="#475569" strokeWidth="3" />
      {parts.map(({ c, i, x, w, load }) => {
        const p = load?.product && PRODUCT_MAP[load.product];
        const cx = x + w / 2;
        return (
          <g key={`l${i}`}>
            <rect x={cx - 14} y={Y - 10} width="28" height="10" rx="2" fill="#334460" />
            <text x={cx} y={Y + 30} textAnchor="middle" className="svg-name">{c.name.split(" ")[0]}</text>
            <text x={cx} y={Y + 58} textAnchor="middle" className="svg-gal">
              {c.locked_dry ? "DRY" : p ? `${fmt(load.gallons)} gal` : "—"}
            </text>
            <text x={cx} y={Y + 78} textAnchor="middle" className="svg-sub">{p ? (load.label ? load.label.slice(0, 14) : "") : `${fmt(c.capacity)} gal`}</text>
            {p?.mark && <text x={cx} y={Y + 96} textAnchor="middle" className="svg-mark" style={{ fill: p.markColor === "#111" ? "#fff" : p.markColor }}>{p.mark}</text>}
            {c.double_bulkhead && <text x={cx} y={Y - 14} textAnchor="middle" className="svg-db">DB</text>}
          </g>
        );
      })}
    </svg>
  );
};
